// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.kyc.KYCLevel1Details

@OptIn(InternalKtorfitApi::class)
public class _KYCLevel1ServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : KYCLevel1Service {
  override fun fetchKYCLevel1Details(clientId: Long): Flow<List<KYCLevel1Details>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "datatables/kyc_level1_details/${"$clientId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<KYCLevel1Details>>>(),)!! 
  }

  override suspend fun addKYCLevel1Details(clientId: Long, kycLevel1Details: KYCLevel1Details) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "datatables/kyc_level1_details/${"$clientId".encodeURLPath()}")
        }
        setBody(kycLevel1Details) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun updateKYCLevel1Details(clientId: Long, kycLevel1Details: KYCLevel1Details) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "datatables/kyc_level1_details/${"$clientId".encodeURLPath()}/")
        }
        setBody(kycLevel1Details) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }
}

public class _KYCLevel1ServiceProvider : ClassProvider<KYCLevel1Service> {
  override fun create(_ktorfit: Ktorfit): KYCLevel1Service = _KYCLevel1ServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createKYCLevel1Service(): KYCLevel1Service = _KYCLevel1ServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
